<script setup lang="ts">
import NitButton from '@/common/components/NitButton/NitButton.vue';
import LangSwitch from '@/PC/components/LangSwitch.vue';
import TimeZonePicker from '@/PC/components/TimeZonePicker.vue';
import { useNotificationStore } from '@/PC/store/notificationStore';
import { usePeriodsStore } from '@/PC/store/periodsStore';
import { useInputStore } from '@/PC/store/inputStore';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import { getFormatter } from '../helpers/formatter'

const periodStore = usePeriodsStore()
const { periodsSorted } = storeToRefs(periodStore)
const { lang, secondaryTimeZone } = storeToRefs(useInputStore())
const periodsText = computed(() => {
  const formatter = getFormatter(lang.value, secondaryTimeZone.value)
  const periodFormatted = periodsSorted.value.map(p => formatter.formatPeriod(p))
  return periodFormatted.join('\n')
})

const input = ref('')
watch(periodsText, (newVal) => {
  input.value = newVal
})

const copy = () => {
  navigator.clipboard.writeText(input.value).then(() => {
    useNotificationStore().showNotification()
  })
}

const reset = () => {
  input.value = ''
  periodStore.removeAll()
}

const textReceiveHost = import.meta.env.VITE_APP_TEXT_RECEIVE_HOST
</script>

<template>
  <section class="controller lo-v fill-wt bg-white">
    <div class="textarea-wrapper">
      <textarea
        class="form-base"
        :class="{ 'textarea-en': lang === 'en' }"
        v-model="input"
        :rows="8"
        :placeholder="'カレンダーから選んだ日時が文字になって自動で入力されます。'"
      />
      <time-zone-picker class="tz-picker-pos" />
      <div class="textarea-controls">
        <lang-switch />
      </div>
    </div>
    <strong-g class="mg-top-8px buttons lo-v-end">
      <nit-button class="mg-top-4px" @click="copy">文字をコピー</nit-button>
      <nit-button class="mg-top-8px border-gray" :type="'tertiary'" @click="reset">リセット</nit-button>
      <a :href="textReceiveHost" target="_blank" class="mg-top-4px lo-h-center text-receive-link">
        <p>
          受け取る君
        </p>
        <img :style="{ marginTop: '2px' }" src="@/assets/external-link-gray.svg" />
      </a>
    </strong-g>
  </section>
</template>

<style scoped>
.controller {
  padding: 96px 32px 0 32px;
  min-width: 320px;
}
.buttons {
  z-index: 10;
}
.reset-button {
  /* 調整値 */
  margin-right: 4px;
}
.text-receive-link {
  font-size: var(--font-size-14px);
  color: var(--font-gray-2);
}
.tz-picker-pos {
  position: absolute;
  top: -24px;
  right: 0;
}
.textarea-wrapper {
  position: relative;
}
.textarea-en {
  font-size: 14px;
}
.textarea-controls {
  position: absolute;
  right: 8px;
  bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
